export const getSeatByPosition = (seatLayout, position) => {
    const area = seatLayout.areas.find(a => a.number === position.areaNumber);
    if (!area)
        return undefined;
    const row = area.rows.find(r => r.number === position.rowNumber);
    if (!row)
        return undefined;
    return row.seats.find(s => s.position.columnNumber === position.columnNumber);
};
/**
 * Gets the seats in the same group as the seat passed in.
 * Returns undefined if the seat is not part of a group.
 */
export const getSeatsInGroup = (seatLayout, seat) => {
    const seatGroupIds = seat.seatGroupIds;
    if (seatGroupIds.length === 0)
        return undefined;
    // We know that grouped seats are always in the same area and row
    const area = seatLayout.areas.find(a => a.number === seat.position.areaNumber);
    if (!area)
        return undefined;
    const row = area.rows.find(r => r.number === seat.position.rowNumber);
    if (!row)
        return undefined;
    return row.seats.filter(s => seatGroupIds.includes(s.id));
};
//# sourceMappingURL=seat-layout-utils.js.map